import ScrollMagic from 'scrollmagic';

const smController = new ScrollMagic.Controller();
let isMobile = 'ontouchstart' in window ? true : false;

if (!isMobile) {
    document.querySelectorAll('.js-tuto-is').forEach(container => {
        const top = container.querySelector('.tuto-is__top');

        const scene = new ScrollMagic.Scene({
            triggerElement: container,
            triggerHook: 1,
            offset: 0,
            duration: window.innerHeight + container.offsetHeight,
            reverse: true
        })
        .on('progress', e => {
            container.style.setProperty('--scroll-progress', e.progress);
        })
        .addTo(smController);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: container,
            triggerHook: 0,
            offset: -100,
            duration: window.innerHeight ,
            reverse: true
        })
        .setPin(top, { pushFollowers: false })
        .on('progress', e => {
            container.style.setProperty('--scroll-pin-progress', e.progress);
        })
        .addTo(smController);

        window.addEventListener('resize', () => {
            scene.duration(window.innerHeight + container.offsetHeight);
            scene2.duration(window.innerHeight );
            scene.refresh();
            scene2.refresh();
        });
    });
}


document.querySelectorAll('.js-hero-anim').forEach(container => {
    let animation = initAnimation(container);

    const debounceResize = debounce(() => {
        animation.destroy();
        animation = initAnimation(container);
    }, 1000);

    window.addEventListener('resize', () => {
        debounceResize();
    });
});

function initAnimation(container) {
    return bodymovin.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: window.innerWidth > 1099 ? container.dataset.src : container.dataset.srcMobile
    });
}

function debounce(func, wait, immediate) {
    let timeout;

    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
